module.exports = __webpack_public_path__ + "img/5-2.c3154d98.png";